export const toolTipStyle = {
  wrapper: {
    display: 'inline-block',
    color: 'actions.600',
    fontSize: '2rem',
  },
};
